export function isWalkable(tile) {
  return (
    [
      'floor',
      'corridor',
      'hidden-corridor',
      'secret-entrance',
      'rest',
      'door-open',
      'chest-open',
      'chest-ransacked',
      'chest-locked',
      'chest-closed',
      'chest-simple-locked',
      'chest-simple-closed',
      'chest-simple-open',
      'chest-rare-locked',
      'chest-rare-closed',
      'chest-rare-open',
      'brazier',
      'merchant',
      'enemy',
      'enemy-boss',
      'chained-penitent-liberated',
      'steps-up',
      'steps-down',
      'storyline',
      'trap',
      'shrine-common',
      'shrine-rare',
      'shrine-mythic',
      'well',
      'witch',
    ].includes(tile) ||
    (typeof tile === 'string' && tile.startsWith('corridor_lab')) ||
    (typeof tile === 'string' && tile.startsWith('bookshelf-')) ||
    (typeof tile === 'string' && tile.startsWith('statue-'))
  );
}
